import { component } from 'picoapp'
import Flickity from 'flickity'

class AsSeenInCarousel {
  constructor(node, ctx) {
    // bindings

    // selectors
    this._node = node
    this._asi_carousel = new Flickity(this._node.getElementsByClassName("as-seen-in-carousel")[0], {
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      autoPlay: true,
      pauseAutoPlayOnHover: false
    });

    // equal heights hack
    Flickity.prototype._createResizeClass = function() {
      this.element.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    let resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call( this );
      this.element.classList.add('flickity-resize');
    };

    this._asi_carousel.resize();

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Unmount.
  //
  unmount() {
    // events
  }
}

export default component((node, ctx) => new AsSeenInCarousel(node, ctx))
